$(document).ready(function(){

  if ($("#cropResearch").length){

    //Popovers
    $(function() {
      $('[data-toggle="popover"]').popover({
          trigger: 'hover',
          html: true
        })
    })

    // Year Start change
    $("#yearStart").change(function(){

      var yearStart = $(this).val();
      var yearEnd = $("#yearEnd").val();

      if (yearStart != ""){

        if (yearEnd != "" && yearEnd<yearStart){
          $("#yearEnd").val('');
        }
      }
    });

    // Year End change
    $("#yearEnd").change(function(){

      var yearStart = $("#yearStart").val();
      var yearEnd = $(this).val();

      if (yearEnd != ""){

        if (yearStart != "" && yearStart>yearEnd){
          $("#yearStart").val('');
        }
      }
    });

    // Country Change
    $("#country").change(function(){
        researchRefreshStates();
    });


    // Disease Category Change
    $("#diseaseCategory").change(function(){
        researchRefreshDiseases();
    });

    // Region Change
    $("#region").change(function(){
        researchRefreshStates();
    });

  }

});


function researchRefreshDiseases(){

  var cropID = $("#cropID").val();
  var diseaseCategoryID = $("#diseaseCategory").val();

  // Clear Categories
  $("#diseases").html("");
  console.log("/crops/getDiseases?crop="+cropID+"&diseaseCategory="+diseaseCategoryID);
  $.getJSON("/crops/getDiseases?crop="+cropID+"&diseaseCategory="+diseaseCategoryID, function( data ) {

    var newHTML = '';
    $.each(data, function(key, disease){
      //console.log(key+" | "+disease);
       newHTML += '<option value="'+key+'">'+disease+'</option>';
    });

    $("#diseases").html(newHTML);

  });

}



function researchRefreshStates(){

  var countryID = $("#country").val();
  var regionID = $("#region").val();
  var cropID = $("#cropID").val();

  // Clear Categories
  $("#states").html("");
  console.log("/crops/getStates?cropID="+cropID+"&country="+countryID+"&region="+regionID);
  $.getJSON("/crops/getStates?cropID="+cropID+"&country="+countryID+"&region="+regionID, function( data ) {

    var newHTML = '';
    $.each(data, function(key, state){
      //console.log(key+" | "+state);
       newHTML += '<option value="'+key+'">'+state+'</option>';
    });

    $("#states").html(newHTML);

  });

}



// WEBPACK FOOTER //
// ./resources/assets/js/public/crop.js